import {api} from '../api';

import type {UsersApiResponse} from '../types';

export function fetch(): Promise<UsersApiResponse> {
    // @ts-ignore
    return api.get('session').then((response) => response.json());
}
